























































































































import { Component, Watch } from "vue-property-decorator";
import { Getter } from "vuex-class";
import { mixins } from "vue-class-component";
import { LanguageDto, ActivityAreaDto, ActivityDto, ActivityStatusDto } from "@/server/app.dtos";
import SideComponent from "@/models/shared/side.component";
import { LayoutServiceBus } from "@/services/bus/layout.service";
import { ActivitiesService } from "@/services/api/activities.service";
import {
  GetActivitiesDtosQuery,
  GetActivitiesDtosIncludeOptions,
  GetActivitiesDtosOrderOptions
} from "@/server/app.queries";
import { ListResponse } from "@/models/grids/list.response";
import {
  ServerGrid,
  DataServerGridOptions
} from "@/components/mixins/ServerGridMixins";
import ActivitiesMenuList from "./shared/MenuList.vue";
import ActivitiesMenuFilters from "./shared/MenuFilters.vue";
import ActivityLogtimeButtonComponent from '@/components/buttons/ActivityLogtime.vue';
import ConfigsService from '@/services/api/configs.service';
import { ChangeActivityStatusCommand } from '@/server/app.commands';


@Component({
  components: {
    LeftMenu: ActivitiesMenuList,
    FiltersMenu: ActivitiesMenuFilters,
    ActivityLogtimeButton: ActivityLogtimeButtonComponent
  }
})
export default class ActivitiesListPage extends mixins(ServerGrid) {
  configsService: ConfigsService = new ConfigsService();
  @Getter("activityAreas") activityAreas!: ActivityAreaDto[];
  @Getter("currentLanguage") currentLanguage!: LanguageDto;
  @Watch("$route", { deep: true })
  onRouteChange() {
    this.Load();
  }
  area: ActivityAreaDto | null = null;
  activityStatus: ActivityStatusDto[] = [];
  activitiesService: ActivitiesService = new ActivitiesService();

  constructor() {
    super();
    this.gridConfigs = new DataServerGridOptions();
  }

  async created() {
    this.LoadArea();
    await this.Load();
  }

  handleClick(activity:any){
    this.viewActivity(activity);
  }

  async LoadArea() {
    const id = this.$route.params.id;
    if (id) {
      const a = this.activityAreas.find(
        (i: ActivityAreaDto) => i.idActivityArea === parseInt(id)
      );
      if (a != null) {
        this.area = a;
      }
    }
     this.gridConfigs.columns = [
      {
        text: "",
        value: "idActivityPriority",
        class: ["icon-column"],
        sortable: false,
        align: "center"
      },
      {
        text: "Tipo",
        value: "activityType.title"
      },
      {
        text: "Estado",
        value: "idActivityStatus",
        class:"w-15"
      },
      {
        text: "Designação",
        value: "title",
        filterable: true,
        filterItem: this.$route.query.title
      },
      {
        text: "Data execução",
        value: "dateStart"
      },
      {
        text: "Envolvidos",
        value: "assignees"
      }
    ];

    if(this.area?.hasLogTime as boolean){
      this.gridConfigs.columns.push(
      {
        text: "Log time",
        value: "hasLogTime",
        align: "center"
      })
    }

    this.gridConfigs.columns.push({
        text: "",
        value: "idActivity",
        align: "end"
    });

    this.GridInit();
    await this.LoadStatus();
  }
  
  async editStatus(item: ActivityDto) {
    const command = new ChangeActivityStatusCommand();
    command.idActivity = item.idActivity;
    command.idActivityStatus = item.idActivityStatus;
     await this.activitiesService
      .ChangeStatus(command)
      .then()
      .catch((error: any) => console.log(error));
  }

  async Load() {
    const request = new GetActivitiesDtosQuery();
    request.init(this.$route.query);
    request.includes = new GetActivitiesDtosIncludeOptions();
    request.includes.activityType = true;
    request.includes.activityArea = true;
    request.includes.activityStatus = true;
    request.includes.activityPriority = true;
    request.includes.assignees = true;
    request.includes.tags = true;
    request.idActivityArea = this.area?.idActivityArea;
    request.orderBy = GetActivitiesDtosOrderOptions.DateStartDesc;
    if (!request.take || request.take <= 0) {
      request.skip = 0;
      request.take = this.gridConfigs.pageSize;
    }
    this.GridSetLoading(true);
    await this.activitiesService
      .GetList(request)
      .then((result: ListResponse<ActivityDto>) => this.GridLoad(result))
      .catch((error: any) => console.log(error))
      .finally(() => this.GridSetLoading(false));
  }
  
  async LoadStatus() {
    // Load ActivityStatus
    await this.configsService.Load("api/activitystatus", "idLanguage=" + this.currentLanguage.idLanguage + "&idActivityArea=" + this.area?.idActivityArea).then(result => {
      this.activityStatus = result;
    });
  }

  viewActivity(activity: ActivityDto): void {
    const comp = new SideComponent();
    comp.title = "DetailActivitySideMenuComponent";
    comp.args = {
      activity: activity
    };
    LayoutServiceBus.openSideMenu(comp);
  }

  createActivity(): void {
    const comp = new SideComponent();
    comp.title = "CreateActivitySideMenuComponent";
    comp.args = {
      activityArea: this.area
    };
    LayoutServiceBus.openSideMenu(comp);
  }
}
